import axios from 'axios';

type DownloadProgress = {
  progress: number;
  speed: number;
  timeLeft: number;
};

export async function uploadFile(
  url: string,
  data: File,
  abortController: AbortController,
  onProgress?: (data: DownloadProgress) => void,
): Promise<void> {
  try {
    const startTime = Date.now();

    await axios.put(url, data, {
      signal: abortController.signal,
      responseType: 'blob',

      onUploadProgress: (event) => {
        if (event.total && onProgress) {
          const now = Date.now();
          const progress = Math.round((event.loaded * 100) / event.total);
          const timeUploading = (now - startTime) / 1000;
          const speed = event.loaded / timeUploading;
          const timeLeft = (event.total - event.loaded) / speed;

          onProgress({
            progress,
            speed,
            timeLeft,
          });
        }
      },
    });
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
}
